import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import MonthItem from '@calendar/components/View/MonthItem.vue'
import WebMailBottom from '@/components/common/WebMailBottom.vue'
import * as types from '@calendar/store/types'
import { mapActions, mapGetters } from 'vuex'
import { debounce } from '@/util'
@Component({
    components: { MonthItem, WebMailBottom },
    computed: {
        ...mapGetters({
            monthMatrix: types.CALENDAR_MONTH_MATRIX_LIST,
            currentDate: types.COMMON_DATE_CURRENT
        })
    },
    methods: {
        ...mapActions({
            changeDateMonthPrev: types.COMMON_DATE_MONTH_PREV,
            changeDateMonthNext: types.COMMON_DATE_MONTH_NEXT,
        })
    }
})
export default class MonthView extends Vue {
    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //
    
    monthMatrix!: Array<Array<calendar.DateItem>>
    currentDate!: calendar.DateItem

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    changeDateMonthNext!: (item: calendar.DateItem) => Promise<any>
    changeDateMonthPrev!: (item: calendar.DateItem) => Promise<any>

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    transName: string = ""

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    onSwipe(direction: string) {
        if(direction === 'left') {           
            this.transName = "trans-left"
            this.$nextTick(() => {
                this.changeMonthNext(this)
            });            
        }   

        if(direction === 'right') {     
            this.transName = "trans-right"
            this.$nextTick(() => {
                this.changeMonthPrev(this)
            });                       
        }
    }

    changeMonthNext = debounce((_this: any) => {  
        _this.transToggle = false;               
        _this.changeDateMonthNext(_this.currentDate)
            .then(() => {
                _this.$nextTick(() => { _this.transToggle = true; });                
            });             
    }, 400, { isImmediate: true });

    changeMonthPrev = debounce((_this: any) => {
        _this.transToggle = false;      
        _this.changeDateMonthPrev(_this.currentDate)
            .then(() => {
                _this.$nextTick(() => { _this.transToggle = true; });  
            });
    }, 400, { isImmediate: true });
}
